import mergeModuleConfigs from 'core/utils/mergeModuleConfigs';
import { sweeps as orgConfig } from 'org/configs/modules.config';
import { SWEEPS_GET_SUCCESS, SWEEPS_GET_FAILURE } from '../actions/types';

const defaultConfig = {
  defaults: {
    api: {
      params: {
      },
      options: {
        success: SWEEPS_GET_SUCCESS,
        failure: SWEEPS_GET_FAILURE,
        cache: { isEnabled: true, isPublishedData: true },
      },
    },
    subscribeOnEmailsOptions: {
      formName: 'UpdateMailPreferences',
      endPoint: 'member.php',
      callback: () => window.location.reload(),
      emailOptions: {
        email_odotw_optin: 1,
        email_news_optin: 1,
        email_solo_optin: 1,
        email_global_optout: 0,
        mrkbool: 1,
      },
    },
    getInactiveSweepsH2Text: (brandDisplayName) => (
      `${brandDisplayName} isn't running a sweepstakes right now`
    ),
  },
};

export default mergeModuleConfigs(defaultConfig, orgConfig);
